export default "__VITE_ASSET__6oLa5kdo__"